module.exports = __webpack_public_path__ + "img/swiper4.d4644f19.png";